import React from 'react'
import youtube from '../../Images/youtube.png'
import facebook from '../../Images/facebook.png'
import twitter from '../../Images/twitter.png'
import insta from '../../Images/insta.png'
import tiktok from '../../Images/tiktok.png'
import snap from '../../Images/snap.png'
import linked from '../../Images/linked.png'
import telegram from '../../Images/telegram.png'

function SocialMedia() {



    return (
        <>
            <div className="flex flex-col mt-20">
                <div className="flex flex-col self-start px-5 text-right">
                    <div className="self-start text-5xl font-bold whitespace-nowrap text-zinc-900">
                        مواقع التواصل
                    </div>
                    <div className="mt-5 text-xl font-medium text-zinc-900">
                        تابعونا على مواقع التواصل الاجتماعي التالية
                    </div>
                </div>
                <div className="px-5 mt-16 w-full max-md:mt-10 max-md:max-w-full">
                    <div className="flex gap-5 max-md:flex-col max-md:gap-0 *:hover:cursor-pointer">
                        <div className="flex flex-col w-3/12 max-md:ml-0 max-md:w-full">
                            <div className="flex justify-center items-center px-12 py-20 w-full bg-gray-50 hover:bg-blue-600 rounded-2xl max-md:px-5 max-md:mt-6">
                                <img
                                    src={facebook}
                                    className="aspect-[1.01] w-[180px]"
                                />
                            </div>
                        </div>
                        <div className="flex flex-col w-3/12 max-md:ml-0 max-md:w-full">
                            <div className="flex justify-center items-center px-12 py-20 w-full bg-gray-50 hover:bg-blue-400 rounded-2xl max-md:px-5 max-md:mt-6">
                                <img
                                    loading="lazy"
                                    src={twitter}
                                    className="aspect-square w-[180px]"
                                />
                            </div>
                        </div>
                        <div className="flex flex-col w-3/12 max-md:ml-0 max-md:w-full">
                            <div className="flex justify-center items-center px-12 py-20 w-full bg-gray-50 hover:bg-red-700 rounded-2xl max-md:px-5 max-md:mt-6">
                                <img
                                    src={youtube}
                                    className="aspect-[0.99] w-[180px]"
                                />
                            </div>
                        </div>
                        <div className="flex flex-col w-3/12 max-md:ml-0 max-md:w-full">
                            <div className="flex flex-col grow max-md:mt-6">
                                <div className="flex justify-center items-center px-12 py-20 bg-gray-50 hover:bg-blue-800 rounded-2xl max-md:px-5">
                                    <img
                                        src={linked}
                                        className="aspect-[0.98] w-[180px]"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="px-5 mt-4 w-full max-md:max-w-full">
                    <div className="flex gap-5 max-md:flex-col max-md:gap-0 *:hover:cursor-pointer">
                        <div className="flex flex-col w-3/12 max-md:ml-0 max-md:w-full">
                            <div className="flex grow justify-center items-center px-12 py-20 w-full bg-gray-50 hover:bg-gradient-to-r from-purple-500 to-pink-500 rounded-2xl max-md:px-5 max-md:mt-6">
                                <img
                                    src={insta}
                                    className="aspect-square w-[180px]"
                                />
                            </div>
                        </div>
                        <div className="flex flex-col w-3/12 max-md:ml-0 max-md:w-full">
                            <div className="flex grow justify-center items-center px-12 py-20 w-full bg-gray-50 hover:bg-black rounded-2xl max-md:px-5 max-md:mt-6">
                                <img
                                    src={tiktok}
                                    className="aspect-[1.01] w-[180px]"
                                />
                            </div>
                        </div>
                        <div className="flex flex-col w-3/12 max-md:ml-0 max-md:w-full">
                            <div className="flex grow justify-center items-center px-12 py-20 w-full bg-gray-50 hover:bg-yellow-500 rounded-2xl max-md:px-5 max-md:mt-6">
                                <img
                                    src={snap}
                                    className="aspect-[1.01] w-[180px]"
                                />
                            </div>
                        </div>
                        <div className="flex flex-col w-3/12 max-md:ml-0 max-md:w-full">
                            <div className="flex grow justify-center items-center px-12 py-20 w-full bg-gray-50 hover:bg-blue-500 rounded-2xl max-md:px-5 max-md:mt-6">
                                <img
                                    src={telegram}
                                    className="aspect-[1.01] w-[180px]"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SocialMedia